<template>
  <div class="results">
    <template v-for="result in results" :key="result.objectID">
      <MediaThumb :result="result"
                  :objectID="result.objectID"
                  :thumbnail="result.thumbnail"
                  :caption="result.caption"
                  @openViewer="openViewer"></MediaThumb>
    </template>
  </div>
</template>

<script>

import {mapActions} from "vuex";

import MediaThumb from "../viewer/MediaThumb";

export default {
  name: "SearchResults",

  components: {
    MediaThumb
  },

  props: {
    results: Object
  },

  data() {
    return {};
  },

  methods: {
    ...mapActions({
      openEntry: 'viewer/openEntryAsync',
    }),

    openViewer(result) {
      this.openEntry(result);
    }
  }
}
</script>

<style lang="scss" scoped>
.results {
  column-count: var(--mgt-results-colum-count);
  column-gap: var(--mgt-results-gap);
  margin-bottom: var(--mgt-results-gap);
}
</style>